import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
// Import Shared Components
import { Loader, SubmitButton } from 'shared-components';
// Import Global Components
import Button from '../../../../components/Button';
// Import Component Styles
import { Form, InputContainer, OutlinedButton } from './styles';

export const AuthForm = ({
  page,
  onSubmit,
  onKeyUp,
  submitButtonDisabled,
  submitButtonText,
  secondaryButtonFunc,
  secondaryButtonText,
  secondaryButtonOutlined,
  loading,
  children,
}) => {
  // Create intl instance
  const intl = useIntl();

  if (loading) return <Loader />;

  const SecondaryButton = secondaryButtonOutlined ? OutlinedButton : Button;

  return (
    <Form onSubmit={onSubmit} onKeyUp={onKeyUp}>
      <InputContainer>{children}</InputContainer>
      <SubmitButton
        value={submitButtonText || intl.formatMessage({
          id: 'auth-submit-button',
          description: 'Auth form submit button',
          defaultMessage: 'Submit',
        })}
        buttonType="primary"
        size="large"
        disabled={submitButtonDisabled}
      />
      {secondaryButtonFunc && (
        <SecondaryButton
          buttonText={secondaryButtonText}
          buttonFor="secondary"
          page={page}
          // `type` is a style prop, not the HTML attribute — this submits
          onClick={e => {
            e.preventDefault();
            secondaryButtonFunc(e);
          }}
          variant="text"
        />
      )}
    </Form>
  );
};

AuthForm.propTypes = {
  page: PropTypes.string.isRequired,
  onKeyUp: PropTypes.func,
  children: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  secondaryButtonText: PropTypes.string,
  secondaryButtonFunc: PropTypes.func,
  secondaryButtonOutlined: PropTypes.bool,
  submitButtonDisabled: PropTypes.bool,
  submitButtonText: PropTypes.string,
};

AuthForm.defaultProps = {
  onKeyUp: null,
  secondaryButtonText: null,
  secondaryButtonFunc: null,
  secondaryButtonOutlined: false,
  submitButtonDisabled: null,
  submitButtonText: null,
};

export const AuthNonForm = ({
  page,
  onClick,
  buttonText,
  secondaryButtonFunc,
  secondaryButtonText,
  loading,
  children,
}) => {
  if (loading) return <Loader />;

  return (
    <Form as="div">
      <InputContainer as="div">{children}</InputContainer>
      {onClick && (
        <Button
          buttonText={buttonText}
          buttonFor="primary"
          page={page}
          onClick={onClick}
          type="primary"
          size="large"
        />
      )}
      {secondaryButtonFunc && (
        <Button
          buttonText={secondaryButtonText}
          buttonFor="secondary"
          page={page}
          onClick={secondaryButtonFunc}
          variant="text"
        />
      )}
    </Form>
  );
};

AuthNonForm.propTypes = {
  page: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonFunc: PropTypes.func,
};

AuthNonForm.defaultProps = {
  secondaryButtonText: null,
  secondaryButtonFunc: null,
  onClick: null,
  buttonText: null,
  loading: null,
};
